import React, { Component } from 'react';
import Modal from './Modal';

import { LEGEND_VALUES } from 'constants/countryProfile';

class LegendTrafficMobile extends Component {
  constructor(props) {
    super(props);

    this.state = { isOpen: false };
    this.toggleModal = this.toggleModal.bind(this);
  }

  toggleModal() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  render() {
    return (
      <div className="c-legend-traffic-mobile no-print">
        <button className="view-legend" onClick={this.toggleModal}>
          <div className="legend-icon"></div> View Legend
        </button>

        <Modal
          show={this.state.isOpen}
          onClose={this.toggleModal}
        >
          <p className="title-legend">Score</p>
          <div className="scores">
            {LEGEND_VALUES.filter(el => !el.mapOnly).map((l, i) => (
              <div key={i} className="legend-item">
                <div className={`color ${l.colorCode}`}></div>
                <div className="label">
                  <span>{l.value}</span>
                  <span>{l.description}</span>
                </div>
              </div>
            ))}
          </div>
        </Modal>
      </div>
    );
  }
}

export default LegendTrafficMobile;



// WEBPACK FOOTER //
// ./app/components/country-profiles/show/LegendTrafficMobile.jsx